import axios from 'axios';

export const presentationApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/presentation`,
    headers: {
        'Content-Type': 'application/json'
    }
})